import { useDispatch } from "react-redux";
import { openPanel, closePanel, togglePanel } from "stores/support/supportSlice";

// The single primitive every surface (Sidebar, header, footer, deep link) uses
// to drive the messenger, so no surface pokes at the slice directly.
export default function useOpenSupport() {
  const dispatch = useDispatch();
  return {
    open: (opts) => dispatch(openPanel(opts || {})),
    close: () => dispatch(closePanel()),
    toggle: () => dispatch(togglePanel()),
  };
}
